const styles = {
    headerTooltip: {
        marginBottom: 5,
        marginLeft: 5
    },
    toggle: {
        marginBottom: 5,
        marginLeft: 20
    }
};

export default styles;
